export const error_unserviceable_text = 'Sorry! No service is available';
export const error_unserviceable_text_bn = 'দুঃখিত! কোন সেবা পাওয়া যায় না';

export const error_unserviceable_sub_text_pickup =
  'We do not serve pickup service from this area. Please change the pickup location';
export const error_unserviceable_sub_text_pickup_bn =
  'আমরা এই এলাকা থেকে পিকআপ পরিষেবা প্রদান করি না। পিক আপ অবস্থান পরিবর্তন করুন';

export const error_unserviceable_sub_text_dropoff =
  'We do not serve dropoff service from this area. Please change the dropoff location';
export const error_unserviceable_sub_text_dropoff_bn =
  'আমরা এই এলাকা থেকে ড্রপঅফ পরিষেবা পরিবেশন না. ড্রপঅফ অবস্থান পরিবর্তন করুন';

export const error_unserviceable_button_pickup = 'Change Pickup Location';
export const error_unserviceable_button_pickup_bn =
  'পিকআপ লোকেশন পরিবর্তন করুন';

export const error_unserviceable_button_dropoff = 'Change Dropoff Location';
export const error_unserviceable_button_dropoff_bn =
  'ড্রপঅফ অবস্থান পরিবর্তন করুন';

export const search_results_title = 'Search Results';
export const search_results_empty_title = 'Start searching for places';
export const search_results_empty_subtitle =
  'Search for nearby landmarks, building name, area or street name';
export const pickup_address = 'Pickup Address';
export const dropoff_address = 'Dropoff Address';

export const error_unserviceable_sub_text =
  'We do not serve pickup service from this area. Please change the location';
export const error_unserviceable_button = 'Change Location';

export const ga_cta_book_select_goods = 'fe_review_select_goods_cta_tap';
export const moe_cta_book_select_goods_parameter =
  'fe_review_select_goods_cta_tap_moe';
export const ga_cta_book_now = 'fe_estresult_cta_confirm_tap';
export const moe_cta_book_now_parameter = 'fe_estresult_cta_confirm_tap_moe';
export const offers_text =
  'Get additional 20% off on this vehicle in the next step.';

export const payment_method = 'Payment Method';
export const payment_method_cash = 'Cash';
export const book_now_button = 'Book Now';
export const view_breakup_button = 'View Breakup';
